'use strict';

document.addEventListener( 'alpine:init', () => {

	Alpine.data( 'primaryNavDesktop', () => ({

		activeSubmenu: null,
		closeTimeout : null,
		innerOpen    : false,
		openTimeout  : null,
		panelOpen    : false,
		duration     : 600,
		easing       : 'ease-in-out',

		init() {
			this.$watch( 'panelOpen', ( value ) => {
				if ( value ) {
					this.$nextTick( () => this.innerOpen = true );
				} else {
					this.innerOpen = false;
				}
			});

			window.addEventListener( 'open-submenu', ( e ) => {
				this.openSubmenu( e.detail.id );
			});
		},

		cancelCloseTimeout() {

			if ( null === this.closeTimeout ) return;

			window.clearTimeout( this.closeTimeout );
			this.closeTimeout = null;
		},

		cancelOpenTimeout() {

			if ( null === this.openTimeout ) return;

			window.clearTimeout( this.openTimeout );
			this.openTimeout = null;
		},

		openSubmenu( id ) {

			// Ignore clicks while an open or close animation is in progress.
			if ( null !== this.openTimeout || null !== this.closeTimeout ) return;

			this.cancelCloseTimeout();

			if ( this.activeSubmenu === id ) {

				if ( this.panelOpen ) {
					this.scheduleClose();
					return;
				}

				this.panelOpen = true;
				this.$refs.siteHeader.classList.add( 'active' );

				return;
			}

			// First open: animate collapse open.

			if ( null === this.activeSubmenu ) {

				this.panelOpen     = false;
				this.activeSubmenu = id;

				this.$nextTick( () => {
					// rAF lets Safari finish layout on the now-visible parent before x-collapse measures the child.
					requestAnimationFrame( () => {
						this.panelOpen = true;
						this.$refs.siteHeader.classList.add( 'active' );
						this.openTimeout = window.setTimeout( () => {
							this.openTimeout = null;
						}, this.duration );
					});
				});

				return;
			}

			// Switch submenu: no collapse animation.

			this.activeSubmenu = id;
			this.panelOpen     = true;
			this.$refs.siteHeader.classList.add( 'active' );
		},

		scheduleClose() {

			if ( null === this.activeSubmenu && ! this.panelOpen ) return;

			this.panelOpen = false;
			this.$refs.siteHeader.classList.remove( 'active' );

			this.cancelCloseTimeout();
			this.closeTimeout = window.setTimeout( () => {
				this.activeSubmenu = null;
				this.closeTimeout  = null;
			}, this.duration );
		},

		closeSubmenus() {

			this.cancelOpenTimeout();
			this.cancelCloseTimeout();
			this.panelOpen = false;
			this.$refs.siteHeader.classList.remove( 'active' );

			this.closeTimeout = window.setTimeout( () => {
				this.activeSubmenu = null;
				this.closeTimeout  = null;
			}, this.duration );
		},

		handleEscapeKey() {

			if ( ! this.panelOpen ) return;

			this.cancelOpenTimeout();
			this.cancelCloseTimeout();
			this.panelOpen = false;
			this.$refs.siteHeader.classList.remove( 'active' );

			this.closeTimeout = window.setTimeout( () => {
				this.activeSubmenu = null;
				this.closeTimeout  = null;
			}, this.duration );

		},
	}) );
});
